import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = { auth: authRoles.processor, routes: [{ path: '/list-silos', component: FuseLoadable({ loader: () => import('./SilosApp') }) }] };

export default [Index];
